import classNames from "classnames";

import IntroAnimation from "../IntroAnimation/IntroAnimation";
import IntroPerformers from "../IntroPerformers/IntroPerformers";
import IntroIllustration from "../IntroIllustration/IntroIllustration";

import { getPlatformType, ICON_CONFIGS } from "./config/iconConfigs";

import "./IntroMarkets.scss";

export default function IntroMarkets({ marketMode, isTablet, isMobile, shouldShowBreadcrumbs }) {
  const path = marketMode?.path ?? '';
  const classes = path.slice(1);
  const classesReviewAvito = path.includes('reviews-na-obyavleniya');
  const classesReviewYandex = path.includes('reviews-on-yandexmaps');
  
  const platformType = getPlatformType(path);
  const iconConfig = ICON_CONFIGS[platformType] || ICON_CONFIGS.default;

  const MessageIconComponent = iconConfig.message;
  const LikeIconComponent = iconConfig.like;
  const EyeIconComponent = iconConfig.eye;
  const HumanIconComponent = iconConfig.human;

  return (
    <div className={classNames("intro-markets", classes)}>
      <IntroPerformers marketMode={marketMode} shouldShowBreadcrumbs={shouldShowBreadcrumbs} />
      <IntroAnimation className={classes} shouldShowBreadcrumbs={shouldShowBreadcrumbs} />
      <div className={classNames("intro-markets__container", classes)}>
        <MessageIconComponent className={classNames("intro-markets__container-message", classes)} />
        <LikeIconComponent className={classNames("intro-markets__container-like", classes)} />
        <EyeIconComponent className={classNames("intro-markets__container-eye", classes)} />
        <HumanIconComponent className={classNames("intro-markets__container-human", classes)} />
      </div>
      {!isMobile && !isTablet && 
        <>
          {classesReviewAvito || classesReviewYandex 
            ? <div className={`intro-markets__container-review ${classesReviewAvito ? 'avito' : 'yandex'}`}/>
            : <IntroIllustration marketMode={marketMode} shouldShowBreadcrumbs={shouldShowBreadcrumbs} />
          }
        </>
      }
    </div>
  );
}